export const rules = {
  'groupCriterion.target.locations': [
    {
      required: true,
      message: '请选择地区',
    },
    {
      validator(rule, value, callback) {
        if (value.length == 0) {
          return callback(new Error('请选择地区'));
        }
        callback();
      },
      trigger: ['blur'],
    },
  ],
  bidAmount: [
    {
      validator(rule, value, callback, source) {
        if (source.bidStrategy === 'TARGET_CPA' && (!value || value.toString().trim() === '')) {
          return callback(new Error('当选择设置广告组目标出价时，出价金额必填'));
        }
        callback();
      },
      trigger: ['blur', 'change'],
    },
  ],
};

